// extracted by mini-css-extract-plugin
module.exports = {"mobileHeaderMenuHolder":"MobileHeaderMenu_mobileHeaderMenuHolder__nccv4"};